<template>
  <div class="containerCenter">
    <div v-if="check == 3" style="padding: 0 0 10px 10px;color: red;">
      <a-icon type="exclamation-circle" />
      已办列表是当前用户所有参与审批的记录，多次审批会有多条记录
    </div>
    <div class="top">
      <a-radio-group v-model="check" @change="handleChange" size="large">
        <a-radio-button v-for="(item, index) in mineList" :value="item.id" :key="index">
          {{ item.title }}
        </a-radio-button>
      </a-radio-group>
    </div>
    <div class="bottom">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'nextView',
  data() {
    return {
      check: 1,
      mineList: [
        {
          id: 1,
          title: '我的待办',
        },
        {
          id: 2,
          title: '我的申请',
        },
        {
          id: 3,
          title: '我的已办',
        },
        {
          id: 4,
          title: '抄送我的',
        },
        {
          id: 5,
          title: '我的或签',
        },
        {
          id: 6,
          title: '我的转交',
        },
      ],
    }
  },
  created() {
    this.$router.push({
      path: '/system/approve',
    })
  },
  methods: {
    handleChange() {
      if (this.check == 1) {
        this.$router.push({
          path: '/system/approve',
        })
      } else if (this.check == 2) {
        this.$router.push({
          path: '/system/business',
        })
      } else if (this.check == 3) {
        this.$router.push({
          path: '/system/taskdone',
        })
      } else if (this.check == 4) {
        this.$router.push({
          path: '/system/copy',
        })
      } else if (this.check == 5) {
        this.$router.push({
          path: '/system/Signature',
        })
      } else if (this.check == 6) {
        this.$router.push({
          path: '/system/Transmit',
        })
      }
    },
  },
}
</script>
<style scoped lang="less">
.containerCenter {
  width: 100%;
  height: 100%;
  float: left;

  .top {
    width: 100%;
    height: 50px;
    float: left;
  }

  .bottom {
    width: 100%;
    height: calc(100% - 50px);
    float: left;
  }

}
</style>

